import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MpsLoaderService } from '../../../../../mps/mps-loader';
import { MpsUserService } from '../../../../../mps/mps-auth';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-reset-password-link',
  templateUrl: './resetPasswordLink.component.html',
  styleUrls: ['./resetPasswordLink.component.scss']
})
export class ResetPasswordLinkComponent implements OnInit {

  @Input() token: string;

  private _loading: boolean;
  public form;
  public resetPasswordLinkSuccessMessage: string;
  public resetPasswordLinkErrorMessage: any;
  public resetPasswordLinkForm: FormGroup;
  public reCaptchaKey = environment.reCaptchaKey;

  public error: any;

  constructor(
    fb: FormBuilder,
    private _userService: MpsUserService,
    private _snackBar: MatSnackBar,
    private _dialogRef: MatDialogRef<ResetPasswordLinkComponent>,
    private _loaderService: MpsLoaderService
  ) {
    this.error = {};

    this.form = fb.group({
      email: ['', [Validators.required, Validators.email]],
      captcha: ['', Validators.required]
    });

  }

  public ngOnInit() {
  }


  public submit() {

    if (this.form.valid && !this._loaderService.isVisible()) {

      this._loaderService.show();

      this._userService.resetPasswordLink(this.form).then(
        (response) => {
          this.form.reset();
          this._loaderService.hide();
          this._snackBar.open(response.message, 'Close', {
            duration: 5000
          });
          this._dialogRef.close();
        }
      ).catch(
        (response) => {
          this._loaderService.hide();
          const message = response.error.errors ? response.error.errors.password[0] : response.error.message;
          this._snackBar.open(message, 'Close', {
            duration: 5000
          });
        }
      );
    }
  }
}
